export default __webpack_public_path__ + "static/media/ch_0.e26884f4.mp3";